export enum Slot {
	PARTNER_BENEFIT = "partnerBenefit",
	BOUNCE_LAYER = "bounce",
}
